import { any, func, string, bool } from "prop-types";
import React from "react";
import styled from "styled-components";
import { RESOLUTIONS } from "services/config";
import { CircleSlash } from "styled_components/SVG/CircleSlash";

const handleColorType = (module, theme) => {
  switch (module.toLowerCase()) {
    case "storage":
      return theme.storage;
    case "account":
      return theme.account;
    case "billing":
      return theme.billing;
    case "support":
      return theme.support;
    case "colocation":
      return theme.colocation;
    default:
      return theme.main;
  }
};
function checkBreakpoint(breakpoint) {
  let screen = "medium";
  if (breakpoint === RESOLUTIONS.LOW) {
    screen = "small";
  } else if (breakpoint === RESOLUTIONS.HIGH) {
    screen = "large";
  }

  return screen;
}

const Button = styled.button`
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 112px;
  height: 112px;
  background-color: ${(props) => props.theme.Cool_Gray_Light_3};
  box-shadow: -4px -4px 12px ${(props) => props.theme.white},
    4px 4px 12px ${(props) => props.theme.boxShadow};
  border-radius: 14px;
  border: none;
  text-align: center;
  outline: none !important;
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: 100%;
  }
  #circle-slash {
    opacity: 0;
    margin-top: 10px;
  }
  &.recent-ticket {
    box-shadow: -2px -2px 6px ${(props) => props.theme.white},
      2px 2px 6px ${(props) => props.theme.boxShadow};
  }
  .icon {
    width: 25px;
    height: 25px;
    margin-bottom: 10px;
  }

  svg {
    width: 50px;
    height: 50px;
  }
  .action-button-text {
    color: ${(props) => props.theme.Cool_Gray_Dark_2};
    overflow: hidden;
    background-size: 250% 150%;
    background-position: 100%;
    transition: background-position 0.7s ease;
    transition-delay: 0.2s;
    text-decoration: none;
    z-index: 1000;
  }
  &.member,
  &.Member {
    opacity: 0.5;
    pointer-events: none;
  }
  &.small {
    width: 80px;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      margin: 0px;
      width: 80px;
      height: 80px;
    }
  }
  &.medium {
    width: 112px;
    height: 112px;
    border-radius: 12px;
  }

  &.xs {
    width: 64px;
    height: 64px;

    img {
      margin: 0px;
      width: 64px;
      height: 64px;
    }
  }
  &.aqua {
    &::before {
      height: 200px;
      width: 400px;
      content: "";
      position: absolute;
      left: 0px;
      right: 0px;
      top: 0px;
      background: #79d2de;
      transform: translatex(-100%);
    }
  }

  &::before {
    height: 200px;
    width: 400px;
    content: "";
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    background: ${(props) => handleColorType(props.module, props.theme)};
    transform: translatex(-100%);
  }
  &.active {
    background-color: ${(props) =>
      handleColorType(props.module, props.theme)} !important;
    transition-delay: 0.3s;
    transition-timing-function: ease;
    transition-property: background-color;
    box-shadow: -1px -1px 6px ${(props) => props.theme.neomhorphicShadowLight} inset,
      1px 1px 6px ${(props) => props.theme.neomhorphicShadowDark} inset !important;
    &.aqua {
      background-color: #79d2de !important;
    }
    &::before {
      animation: diagonal-swipe 1s ease forwards;
      transition-delay: 0.3s;
      transition-property: opacity;
      transition-timing-function: ease;
      opacity: 0;
      transition-duration: 0.3s;
    }

    #special-id-1 {
      .cls-1 {
        fill: url(#special-id-1-swipe-gradient);
      }
      .cls-2 {
        fill: url(#special-id-1-linear-gradient-cog-2);
      }
    }
    #special-id-2 {
      .cls-1 {
        fill: url(#special-id-2-swipe-gradient);
      }
      .cls-2 {
        fill: url(#special-id-2-linear-gradient-cog-2);
      }
    }
    #special-id-3 {
      .cls-1 {
        fill: url(#special-id-3-swipe-gradient);
      }
      .cls-2 {
        fill: url(#special-id-3-linear-gradient-cog-2);
      }
    }
    #special-id-4 {
      .cls-1 {
        fill: url(#special-id-4-swipe);
      }
    }
    #special-id-5 {
      .cls-1 {
        fill: url(#special-id-5-swipe);
      }
    }
    #special-id-6 {
      .cls-1 {
        fill: url(#special-id-6-swipe);
      }
    }
    .action-button-text {
      overflow: hidden;
      background: linear-gradient(
        45deg,
        ${(props) => props.theme.Cool_Gray_Light_3} 49%,
        ${(props) => handleColorType(props.module, props.theme)} 50%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-size: 250% 150%;
      background-position: 0% 100%;
      transition: background-position 0.5s ease;
      transition-delay: 0.1s;
      text-decoration: none;
    }
  }
  &.selected {
    box-shadow: -1px -1px 6px ${(props) => props.theme.white} inset,
      1px 1px 6px ${(props) => props.theme.neomhorphicShadowDark} inset !important;

    background-color: ${(props) => props.theme.Cool_Gray_Light_3};
    &.medium {
      box-shadow: -1px -1px 6px ${(props) => props.theme.white} inset,
        1px 1px 6px ${(props) => props.theme.neomhorphicShadowDark} inset !important;
    }
    &.large {
      box-shadow: -6px -6px 12px ${(props) =>
            props.theme.neomhorphicShadowLight} inset,
        6px 6px 12px ${(props) => props.theme.neomhorphicShadowDark} inset !important;
    }
  }
  &:hover {
    box-shadow: -2px -2px 4px ${(props) => props.theme.white} inset,
      2px 2px 3px ${(props) => props.theme.neomhorphicShadowDark} inset;
    background-color: ${(props) => props.theme.Cool_Gray_Light_3};
    #circle-slash {
      opacity: 1;
    }
    &.medium {
      box-shadow: -3px -3px 6px ${(props) => props.theme.white} inset,
        3px 3px 6px ${(props) => props.theme.neomhorphicShadowDark} inset;
    }
    &.large {
      box-shadow: -6px -6px 10px ${(props) => props.theme.white} inset,
        6px 6px 10px ${(props) => props.theme.neomhorphicShadowDark} inset;
    }

    #special-id-1 {
      .cls-1 {
        fill: url(#special-id-1-linear-gradient-cog);
      }
    }
    #special-id-2 {
      .cls-1 {
        fill: url(#special-id-2-linear-gradient-cog);
      }
    }
    #special-id-3 {
      .cls-1 {
        fill: url(#special-id-3-linear-gradient-cog);
      }
    }
    #special-id-4 {
      .cls-1 {
        fill: url(#special-id-4-guest-access-swipe);
      }
    }
    #special-id-5 {
      .cls-1 {
        fill: url(#special-id-5-guest-access-swipe);
      }
    }
    #special-id-6 {
      .cls-1 {
        fill: url(#special-id-6-guest-access-swipe);
      }
    }
    &.active {
      background-color: ${(props) => props.theme.support};
      box-shadow: -7px -7px 8px ${(props) => props.theme.neomhorphicShadowLight}
          inset,
        7px 7px 8px ${(props) => props.theme.neomhorphicShadowDark} inset;

      #special-id-1 {
        .cls-1 {
          fill: url(#special-id-1-swipe-gradient);
        }
      }
      #special-id-2 {
        .cls-1 {
          fill: url(#special-id-2-swipe-gradient);
        }
      }
      #special-id-3 {
        .cls-1 {
          fill: url(#special-id-3-swipe-gradient);
        }
      }
      #special-id-4 {
        .cls-1 {
          fill: url(#special-id-4-swipe);
        }
      }
      #special-id-5 {
        .cls-1 {
          fill: url(#special-id-5-swipe);
        }
      }
      #special-id-6 {
        .cls-1 {
          fill: url(#special-id-6-swipe);
        }
      }
    }
  }
  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    width: 160px;
    height: 160px;
    box-shadow: -8px -8px 15px ${(props) => props.theme.white},
      8px 8px 20px ${(props) => props.theme.boxShadow};
    border-radius: 24px;
    svg {
      width: 80px;
      height: 80px;
    }

    &.small {
      min-width: 104px;
      height: 104px;
      img {
        min-width: 104px;
        height: 104px;
      }
    }
    &.medium {
      width: 112px;
      height: 112px;
    }

    &.xs {
      width: 72px;
      height: 72px;
      border-radius: 10px;
      img {
        width: 72px;
        height: 72px;
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    width: 272px;
    height: 272px;
    box-shadow: -12px -12px 20px ${(props) => props.theme.white},
      12px 12px 20px ${(props) => props.theme.boxShadow};
    border-radius: 24px;
    svg {
      width: 136px;
      height: 136px;
    }
    &.small {
      width: 160px;
      height: 160px;
    }
    &.medium {
      width: 200px;
      height: 200px;
    }
    .icon {
      width: 45px;
      height: 45px;
      margin-bottom: 20px;
    }

    &.xs {
      width: 176px;
      height: 176px;
      img {
        width: 176px;
        height: 176px;
      }
    }

    &::before {
      height: 450px;
      width: 650px;
    }
    &.active {
      transition-delay: 0.3s;

      &::before {
        animation: diagonal-swipe 0.6s ease forwards;
        transition-delay: 0.3s;
      }
    }
  }
`;

export const ActionButton = ({
  children,
  className,
  id,
  onClick,
  onMouseOver,
  module,
  enabled,
  breakpoint,
  cypressId,
}) => {
  const screen = checkBreakpoint(breakpoint);
  return (
    <Button
      id={id}
      className={className}
      onClick={onClick}
      onMouseOver={onMouseOver}
      module={module}
      data-cy={cypressId}
    >
      {children}
      {!enabled && <CircleSlash module={module} className={screen} />}
    </Button>
  );
};
ActionButton.propTypes = {
  children: any,
  className: string,
  id: string,
  onClick: func,
  onMouseOver: func,
  module: string,
  enabled: bool,
};

ActionButton.defaultProps = {
  children: "",
  className: "action-button",
  id: "action-button",
  onClick: () => {},
  onMouseOver: () => {},
  module: "support",
  enabled: true,
};
